module.exports = __webpack_public_path__ + "static/media/logo@2x.4fca0036.png";